<template>
  <div class="courses-containers container main-view">
    <div>
      <div style="min-height: 500px;" class="mt-20">
        <el-row :gutter="20">
          <el-col
            class="mb-20 desktop"
            :xs="24"
            :sm="15"
            :md="15"
            :lg="15"
            :xl="15"
          >
            <div>
              <div class="list-order">
                <div class="flex justify-space-between align-center">
                  <h4 class="fw-600">Order Summery</h4>
                  <i style="font-weight: 800;" class="el-icon-arrow-down"></i>
                </div>
              </div>
              <div
                v-for="(item, index) in listOrder"
                :key="index"
                class="mt-20"
              >
                <CardOrder :object-data="item" />
              </div>
              <!-- <div class="mt-20">
              <CardOrder />
            </div> -->
            </div>
          </el-col>

          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div v-loading="isLoading" class="info-container">
              <div class="flex justify-space-between align-center">
                <h4 class="fw-600">Info</h4>
                <i style="font-weight: 800;" class="el-icon-arrow-down"></i>
              </div>
              <div class="mt-10 mb-20">
                <search-voucher @change-select-voucher="handleAddVoucher" />
              </div>
              <div
                style="height:1px; width:100%; background:rgba(227, 227, 227, 1)"
              ></div>
              <div class="mt-20">
                <div class="flex justify-space-between align-center">
                  <p
                    style="color:rgba(73, 73, 73, 1);"
                    class="fw-600 c-caption"
                  >
                    Original price:
                  </p>
                  <p
                    style="color:rgba(73, 73, 73, 1);"
                    class="fw-600 c-caption"
                  >
                    {{ formatNumber(amount.origin_amount) }} $
                  </p>
                </div>
                <div class="flex justify-space-between align-center mb-10">
                  <p
                    style="color:rgba(73, 73, 73, 1);"
                    class="fw-600 c-caption"
                  >
                    Discount price:
                  </p>
                  <p
                    style="color: rgba(142, 145, 149, 1);"
                    class="fw-600 c-caption"
                  >
                    {{ formatNumber(amount.discount_amount) }} $
                  </p>
                </div>
              </div>
              <div
                style="height:1px; width:100%; background:rgba(227, 227, 227, 1)"
              ></div>
              <div class="mt-20 mb-10">
                <div class="flex justify-space-between align-center">
                  <p style="color:#242F41;" class="fw-600 c-body2">Total:</p>
                  <p style="color:#035AE0;" class="fw-600 c-title2">
                    {{ formatNumber(amount.payment_amount) }} $
                  </p>
                </div>
              </div>
              <div
                style="height:1px; width:100%; background:rgba(227, 227, 227, 1)"
              ></div>
              <div class="mt-20">
                <div>
                  <el-button
                    :loading="loadingPayment"
                    @click="handlePaypal"
                    class="add-courses"
                  >
                    Pay via Paypal
                  </el-button>
                </div>
                <!-- <div>
                  <p style="line-height: 1.5;color:#494949">
                    Bạn vui lòng quét mã QR bên dưới để thực hiện thanh toán
                    chuyển khoản qua Ngân Hàng sau đó nhấn xác nhận đã thanh
                    toán để hệ thống kiểm tra
                  </p>
                  <img
                    class="mt-10"
                    style="border-radius:4px"
                    :src="dataPayment.qrcode"
                    alt=""
                  />
                </div> -->
                <!-- <div>
                  <el-button
                    :loading="isLoadingSubmit"
                    @click="handleConfirmPayment"
                    class="add-courses"
                  >
                    Xác nhận thanh toán
                  </el-button>
                </div> -->
              </div>
              <!-- <div v-else>
              <el-button
                :loading="isLoadingSubmit"
                @click="onGetPurchase"
                class="add-courses"
              >
                Xác nhận thanh toán
              </el-button>
            </div> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="dialog-container">
        <DialogNoti
          :show-dialog="showDialog"
          :text-msg="messageNoti"
          @on-close-dialog="showDialog = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ImageTeacher from "@/assets/img/img_edu/Video.png";
import QrCode from "@/assets/img/img_edu/QrCode.png";
import StarIcon from "@/assets/img/svg_edu/star.svg";
import UserIcon from "@/assets/img/svg_edu/UserIcon.svg";
import HatIcon from "@/assets/img/svg_edu/HatIcon.svg";
import CheckBoxIcon from "@/assets/img/svg_edu/CheckBox.svg";
import { getOrder } from "../../../utils/orders";
import CardOrder from "@/views/components/card/CardOrder.vue";
import SearchVoucher from "@/views/components/search/SearchVoucher.vue";
import CoursesPurchaseResource from "@/views/api/course-purchase.js";
import { formatNumber } from "@/utils/formatData";
import { isEmpty } from "@/utils/validate";
import DialogNoti from "@/views/components/DialogNoti.vue";
import { signHmacSHA256 } from "@/utils/crypto";
import { getInfo, getToken } from "../../../utils/auth";
export default {
  name: "detai-courses",
  props: {},
  components: {
    CardOrder,
    SearchVoucher,
    DialogNoti
  },
  created() {
    this.onGetPaymentAmount();
    this.onGetPurchase();
    // this.onGetTransaction()
  },
  mounted() {
    const orders = getOrder() || [];
    this.$logEvent(this.$analytics, "view_course_payment", {
      course_name: `ID:${orders[0]?.course_id} -  ${orders[0].headline}`
    });
  },
  data() {
    return {
      loadingPayment: false,
      isShowQr: false,
      messageNoti: "",
      showDialog: false,
      dataPayment: {},
      amount: {},
      isLoading: false,
      isLoadingSubmit: false,
      listOrder: getOrder() || [],
      voucher_id: null,
      value: "",
      img: {
        ImageTeacher,
        QrCode
      },
      icons: {
        HatIcon,
        UserIcon,
        StarIcon,
        CheckBoxIcon
      }
    };
  },
  watch: {},
  methods: {
    handlePaypal() {
      console.log(getInfo());
      if (isEmpty(this.dataPayment)) return;
      this.$logEvent(this.$analytics, "confirm_payment_courses", {
        course_name: `ID:${this.listOrder[0]?.course_id} -  ${this.listOrder[0].headline}`
      });
      this.loadingPayment = true;
      const bodySign = {
        money: this.amount.payment_amount,
        type: "paypal",
        callback_url: `https://hocvivu.com/Courses/Detail/${this.listOrder[0]?.course_id}?transaction_id=${this.dataPayment.transaction_id}`,
        desc: this.dataPayment.payment_content,
        customer_id: getInfo().user_id,
        ipn_url: "https://payment.api4hub.com/api/provider/hocvivu/ipn"
      };
      const valuesArray = Object.values(bodySign);
      const dataToSign = valuesArray.join("|");
      console.log("dataToSign_________", dataToSign);
      const cert = signHmacSHA256(dataToSign);
      console.log("cert_________", cert);
      const postFrom = {
        ...bodySign,
        type: "paypal",
        cert
      };
      CoursesPurchaseResource.Palpay(postFrom)
        .then(res => {
          console.log("res_________", res);
          if (res.error !== 0) {
            this.$message.error(res.error_msg);
            return;
          } else {
            window.location.href = res.link;
          }
        })
        .finally(() => {
          this.loadingPayment = false;
        });
    },
    onGetTransaction() {
      const body = { page: 1, limit: 10, status: 1 };
      CoursesPurchaseResource.ListTracsaction(body).then(res => {
        console.log("ListTracsaction-____", res);
      });
    },
    handleAddVoucher(voucher_id) {
      this.voucher_id = voucher_id || null;
      // if(this.isShowQr) {
      // }
      this.onGetPaymentAmount(voucher_id);
      this.onGetPurchase(voucher_id);
    },
    handleConfirmPayment() {
      if (isEmpty(this.dataPayment)) return;
      this.isLoadingSubmit = true;
      this.$logEvent(this.$analytics, "confirm_payment_courses", {
        course_name: `ID:${this.listOrder[0]?.course_id} -  ${this.listOrder[0].headline}`
      });
      CoursesPurchaseResource.CheckTransaction({
        transaction_id: this.dataPayment.transaction_id
      })
        .then(res => {
          // const { error_code, data, error_msg } = res;
          if (res.error_code !== 0) {
            this.$message.error(res.error_msg);
            return;
          }
          this.showDialog = true;
          this.messageNoti = res.data.message;
        })
        .finally(() => {
          this.isLoadingSubmit = false;
        });
    },
    onGetPurchase(voucher_id = null) {
      const listOrder = getOrder();
      const course_ids = listOrder.map(i => i.course_id);
      const body = { course_ids, voucher_id };
      // this.isLoadingSubmit = true;
      this.isLoading = true;
      CoursesPurchaseResource.Purchase(body)
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            this.$message.warning(error_msg);
            return;
          }
          // this.isShowQr = true;
          this.dataPayment = data || {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onGetPaymentAmount(voucher_id = null) {
      const listOrder = getOrder();
      const course_ids = listOrder.map(i => i.course_id);
      const body = { course_ids, voucher_id };
      CoursesPurchaseResource.GetPaymentAmount(body).then(res => {
        const { error_code, data, error_msg } = res;
        if (error_code !== 0) {
          // this.$message.warning(error_msg)
          return;
        }
        this.amount = data || {};
      });
    },
    formatNumber
  }
};
</script>

<style scoped>
.add-courses {
  border-radius: 32px;
  background-color: #035ae0;
  color: #ffff;
  width: 100%;
  min-height: 48px;
  font-weight: 600;
  font-size: 16px;
  margin: 20px 0;
}
.add-courses:hover {
  background-color: #035ae0;
  color: #ffff;
}
.info-container {
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 20px 40px 0px #0000000f;
  background: #fff;
}
.img-teacher {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.title {
  font-size: 29px;
  font-weight: 700;
  line-height: 52.8px;
  text-align: left;
  margin: 10px 0;
  padding: 0;
}
.courses-containers {
}
.main-view {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .main-view {
    padding-top: 60px;
  }
}
</style>
